"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.EditorialContentGridDefaultProps = exports.EditorialContentGrid = void 0;
var _editorialContentGrid = _interopRequireDefault(require("./components/editorial-content-grid"));
exports.EditorialContentGrid = _editorialContentGrid["default"];
var _editorialContentGrid2 = _interopRequireDefault(require("./components/editorial-content-grid.props/editorial-content-grid.defaultProps"));
exports.EditorialContentGridDefaultProps = _editorialContentGrid2["default"];